export const MAJOR = 'major';
export const MINOR = 'minor';
export const MICRO = 'micro';
